import React from 'react';
import pf1 from "../assets/images/project-development.jpg";
import pf2 from "../assets/images/project-youtube.jpg";
import pf3 from "../assets/images/project-reiki.jpg";

const Portfolio = () => {
    return (
        <section id="portfolio">
            <div className="container">
                <div className="row">
                    <div className="col col-md-8 mx-auto">
                        <div className="p-0">
                            <div id="carouselCaptions" className="carousel slide" data-ride="carousel">
                                <ol className="carousel-indicators">
                                    <li data-target="#carouselCaptions" data-slide-to="0" className="active"></li>
                                    <li data-target="#carouselCaptions" data-slide-to="1"></li>
                                    <li data-target="#carouselCaptions" data-slide-to="2"></li>
                                </ol>
                                <div className="carousel-inner carousel-box">
                                    <div className="carousel-item active">
                                        <img src={pf1} className="d-block w-100 carousel-image" alt="Aahok" />
                                        <div className="carousel-caption d-none d-md-block">
                                            <h5 className="text-warning">Development</h5>
                                            <p className="text-warning">Enterprise ready web/mobile apps.</p>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <img src={pf2} className="d-block w-100 carousel-image" alt="Youtube" />
                                        <div className="carousel-caption d-none d-md-block">
                                            <h5 className="text-warning">Youtube Channel</h5>
                                            <p className="text-warning">A versatile channel for all.</p>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <img src={pf3} className="d-block w-100 carousel-image" alt="Reiki" />
                                        <div className="carousel-caption d-none d-md-block">
                                            <h5 className="text-warning">Reiki</h5>
                                            <p className="text-warning">Heal from within with Reiki.</p>
                                        </div>
                                    </div>
                                </div>
                                <a className="carousel-control-prev" href="#carouselCaptions" role="button" data-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="sr-only">Previous</span>
                                </a>
                                <a className="carousel-control-next" href="#carouselCaptions" role="button" data-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Portfolio
